import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Screen } from '../components/Screen';

const actions = [
  {
    to: '/categories',
    title: 'Browse Templates',
    subtitle: 'Pick a style, drop in your media',
    emoji: '🎬',
    accent: 'from-brand-600/60 to-brand-400/20',
  },
  {
    to: '/templates',
    title: 'Trending',
    subtitle: 'What everyone is making right now',
    emoji: '🔥',
    accent: 'from-accent-500/50 to-brand-500/20',
  },
  {
    to: '/projects',
    title: 'My Projects',
    subtitle: 'Continue where you left off',
    emoji: '📁',
    accent: 'from-white/10 to-white/5',
  },
];

export default function Landing() {
  return (
    <Screen className="flex flex-col justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="mb-10 text-center"
      >
        <p className="mb-2 text-sm font-semibold uppercase tracking-[0.3em] text-brand-400">
          Klooma
        </p>
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">
          Turn moments into
          <span className="bg-gradient-to-r from-brand-400 to-accent-400 bg-clip-text text-transparent">
            {' '}
            videos
          </span>
        </h1>
        <p className="mx-auto mt-3 max-w-md text-white/60">
          Pick a template, add your photos and clips, and get a ready-to-share video in seconds.
        </p>
      </motion.div>

      <div className="mx-auto grid w-full max-w-md gap-4">
        {actions.map((a, i) => (
          <motion.div
            key={a.to}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 + i * 0.08, duration: 0.35 }}
          >
            <Link
              to={a.to}
              className={`glass flex items-center gap-4 rounded-3xl bg-gradient-to-br p-5 transition hover:scale-[1.02] hover:bg-white/10 active:scale-[0.99] ${a.accent}`}
            >
              <span className="text-3xl">{a.emoji}</span>
              <span>
                <span className="block text-lg font-bold">{a.title}</span>
                <span className="block text-sm text-white/60">{a.subtitle}</span>
              </span>
              <span className="ml-auto text-white/40">→</span>
            </Link>
          </motion.div>
        ))}
      </div>
    </Screen>
  );
}
